import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 200]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0]);
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-tx-primary bg-noise pt-20" data-id="element-125">
      {/* Background Poster Image with Parallax */}
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 z-0" data-id="element-126">
        <div className="absolute inset-0 bg-gradient-to-b from-tx-primary/80 via-tx-primary/40 to-tx-primary z-10" data-id="element-127" />
        <img src="https://cdn.magicpatterns.com/uploads/7MLRSpe3TwZ29SF6W4AnZB/bdb49c5e-1444-4c0a-ab47-49b639ad01b0.jpg" alt="Texarkana Band Poster Background" className="w-full h-full object-cover object-center opacity-40 grayscale" data-id="element-128" />
      </motion.div>

      <div className="relative z-20 max-w-5xl mx-auto px-4 flex flex-col items-center text-center mt-12 md:mt-0" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-6" data-id="element-130">
          <Star className="w-16 h-16 md:w-24 md:h-24 text-tx-cream fill-current" data-id="element-131" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-7xl md:text-9xl lg:text-[12rem] font-heading text-tx-cream leading-none tracking-tighter text-shadow-lg mb-4" data-id="element-132">
          TEXARKANA
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-133">
          <p className="text-xl md:text-3xl font-heading tracking-widest text-tx-cream/90 mb-8 uppercase text-shadow-md flex items-center gap-4" data-id="element-134">
            <span className="h-[1px] w-12 bg-tx-red hidden md:block" data-id="element-135"></span>
            Southern Rock & Country • Live
            <span className="h-[1px] w-12 bg-tx-red hidden md:block" data-id="element-136"></span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-137">
            <a href="#booking" className="w-full sm:w-auto" data-id="element-138">
              <Button size="lg" className="w-full" data-id="element-139">
                Book Us
              </Button>
            </a>
            <a href="#tour" className="w-full sm:w-auto" data-id="element-140">
              <Button variant="outline" size="lg" className="w-full" data-id="element-141">
                See Tour Dates
              </Button>
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2" data-id="element-142">
        <span className="font-heading text-sm tracking-widest text-tx-cream/50 uppercase" data-id="element-143">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-tx-border relative overflow-hidden" data-id="element-144">
          <motion.div animate={{
          y: [0, 48, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'linear'
        }} className="absolute top-0 left-0 w-full h-1/2 bg-tx-red" data-id="element-145" />
        </div>
      </motion.div>
    </section>;
}